import React, {Component} from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import './Modal.scss';

ReactModal.setAppElement('body');

class ModalSplit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasCloseBottom: false,
      isSplitScreen: false
    }
  }

  componentWillMount() {

  }

  onAfterOpen(e) {
    // console.log('event', e);
    // console.log('modal', this.modal)
    // this.modal.addEventListener('wheel', (e) => {
    //   e.stopPropagation();
    // });
    // this.modal.addEventListener('mousewheel', (e) => {
    //   e.stopPropagation();
    // });
    //
    // this.modal.addEventListener('touchmove', (e) => {
    //   e.stopPropagation();
    // });
    let modalContent = this.modal.children[0]
    let rect = modalContent.getBoundingClientRect();

    this.setState({
      hasCloseBottom: rect.height > 1000
    })
  }


  onSplitScreen(val) {
      this.setState({
        isSplitScreen: val
      })
  }

  renderChildren() {
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        onSplitScreen: this.onSplitScreen.bind(this),
        isSplitScreen: this.state.isSplitScreen
      });
    });
  }

  onClose() {
    this.setState({isSplitScreen: false})
    this.props.onClose()
  }

  render() {
    let {isOpen, title, size} = this.props;

    return (
      <ReactModal
        portalClassName="modal-portal"
        overlayClassName={classNames("modal-split-overlay", {split: this.state.isSplitScreen} )}
        className={classNames('modal-content', size, this.props.class)}
        closeTimeoutMS={300}
        isOpen={isOpen}
        onAfterOpen={this.onAfterOpen.bind(this)}
        overlayRef={ref => this.modal = ref}>
        <div className="modal-header">
          <div className='title'>{title}</div>
          <div className='close' onClick={() => this.onClose()}>
            <i className="fa fa-close"/>
          </div>
        </div>
        {this.renderChildren()}
        {this.state.hasCloseBottom && !this.state.isSplitScreen && (
          <div onClick={() => this.onClose()} className="close-modal-button">close</div>
        )}
        {this.state.isSplitScreen && (
          <div onClick={(e) => {
            e.stopPropagation()
            this.setState({isSplitScreen: false})
          }} className="close-modal-button">close split screen</div>
        )}
      </ReactModal>
    )
  }
}

export default ModalSplit;
